import { axiosDelete, axiosGet, axiosPost, axiosPut, getSeparator } from "@/helpers";

export const contactPerson = {
  list,
  create,
  detail,
  update,
  remove,
  listByPartner,
};

function list(page, itemsPerPage, sort, search) {
  let url = "/api/v1/contact-persons/";
  if (page) {
    url += `?page=${page}&page_size=${itemsPerPage}`;
  }
  if (sort) {
    url += `${getSeparator(url)}ordering=${sort}`;
  }
  if (search) {
    url += `${getSeparator(url)}search=${search}`;
  }
  return axiosGet(url);
}

function create(data) {
  return axiosPost("/api/v1/contact-persons/", data);
}

function detail(id) {
  return axiosGet(`/api/v1/contact-persons/${id}/`);
}

function update(id, data) {
  return axiosPut(`/api/v1/contact-persons/${id}/`, data);
}

function remove(id) {
  return axiosDelete(`/api/v1/contact-persons/${id}/`);
}

function listByPartner(partnerId) {
  return axiosGet(`/api/v1/contact-persons/?partner=${partnerId}`);
}
